import en from './strings.en';

const ru = {
    addToBoards: 'пригласить на площадку',
    addToList: 'добавить в список',
    firmsCountSelectedPlural: {
        zero: 'Выбрано {{count}} фирм',
        one: 'Выбрана {{count}} фирма',
        few: 'Выбраны {{count}} фирмы',
        many: 'Выбрано {{count}} фирм',
        other: 'Выбрано {{count}} фирм'
    },
    selectAllOnThePage: 'Выбрать все на странице',
    addSelectedToBoards: 'Приглашайте выбранных перевозчиков к себе на\u00A0площадку'
};

export default { ru, en: { ...ru, ...en} };
